import {LockClosedIcon} from '@heroicons/react/20/solid';

export function AccessCodeFormContent({
  submitting = false,
  error,
}: {
  submitting: boolean;
  error?: string;
}) {
  return (
    <>
      <div>
        <label htmlFor="access_code" className="sr-only">
          Access code
        </label>
        <input
          id="access_code"
          name="access_code"
          type="text"
          autoComplete="off"
          minLength={3}
          required
          data-lpignore={true}
          className="relative block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-accent focus:outline-none focus:ring-accent sm:text-sm"
          placeholder="Access code"
        />
        {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
      </div>

      <button
        type="submit"
        disabled={submitting}
        className="group relative flex w-full justify-center rounded-md border border-transparent bg-accent py-2 px-4 text-sm font-medium text-white hover:bg-accent-dark focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
      >
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <LockClosedIcon
            className="h-5 w-5 text-white group-hover:text-accent"
            aria-hidden="true"
          />
        </span>
        Continue
      </button>
    </>
  );
}
